<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Bulk Report Card</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <a href="javascript:;" class="btn btn-sm btn-dark btn-with-addon"
            @click="handleBackButton"
          >
            <span class="btn-addon">
              <i class="btn-addon-icon fe fe-chevron-left" />
            </span>
            Back
          </a>
        </div>
      </div>
    </div>
    <div class="position-relative" id="examResultSingle" style="font-size:13px">
      <div
        class="content"
        v-for="(allData, index) in this.enrollment"
        :key="index"
        style="height:778.5px"
      >
        <neo-print-wrapper title="Exam Report">
          <a-spin :spinning="loading">
            <div class="row" style="font-size:15px">
              <div class="col-12">
                <b style="margin-bottom:3px">
                  {{ allData.student.first_name }}
                  {{ allData.student.last_name }}
                </b>
                <p class="mb-2">
                  Student code:
                  <span class="font-weight-bold">{{
                    allData.student.student_code
                  }}</span>
                  | Class:
                  <span class="font-weight-bold">
                    {{ className }}
                    </span>
                  | Section:
                  <span class="font-weight-bold">
                    {{ sectionName }}
                    </span>
                  | Roll No:
                  <span class="font-weight-bold">{{
                    allData.roll_no
                  }}</span>
                </p>
              </div>
            </div>
            <!-- Report card format -->
            <div class="row">
              <!-- pre-kg -->
              <div class="col-12" v-if="reportCardFormat === 2">
                <vue-custom-scrollbar class="scroll-area">
                  <!-- trail -->
                  <table
                    class="table table-sm table-sm-responsive table-bordered "
                    style="font-size:13px" id="markTable"
                  >
                    <!-- top -->
                    <tr>
                      <th></th>
                      <th :colspan="3" style="text-align: center">
                        X-Periodic Tests + Internal Assessment <br />
                        Marks Secured
                      </th>
                      <th style="text-align: center">
                        Y-1st & 2nd Term Test <br />
                        Marks Secured
                      </th>
                      <th></th>
                    </tr>

                    <!--  2nd row subject and Exam column-->
                    <!-- if length = 4 -->
                    <tr v-if="allData.exams.length === 4">
                      <th class="text-center" style="width:16.66%">SUBJECT</th>
                      <th
                        class="text-center"
                        v-for="(data, index) in allData.exams"
                        :key="index"
                        style="width:16.66%"
                      >
                        {{ data.name }}
                      </th>
                      <th class="text-center" style="width:16.66%">
                        Final Result <br />
                        (X+Y)/2 <br />
                      </th>
                    </tr>
                    <!-- if length = 3 -->
                    <tr v-if="allData.exams.length === 3">
                      <th class="text-center" style="width:16.66%">SUBJECT</th>
                      <th
                        class="text-center"
                        v-for="(data, index) in allData.exams"
                        :key="index"
                        style="width:16.66%"
                      >
                        {{ data.name }}
                      </th>
                      <th class="text-center" style="width:16.66%">2nd Term Test</th>
                      <th class="text-center" style="width:16.66%">
                        Final Result <br />
                        (X+Y)/2 <br />
                      </th>
                    </tr>
                    <!-- if length = 2 -->
                    <tr v-if="allData.exams.length === 2">
                      <th class="text-center" style="width:16.66%">SUBJECT</th>
                      <th style="width:16.66%"
                        class="text-center"
                        v-for="(data, index) in allData.exams"
                        :key="index"
                      >
                        {{ data.name }}
                      </th>
                      <th class="text-center" style="width:16.66%">1st Term test</th>
                      <th class="text-center" style="width:16.66%">2nd Term Test</th>
                      <th class="text-center" style="width:16.66%">
                        Final Result <br />
                        (X+Y)/2 <br />
                      </th>
                    </tr>
                    <!-- if length = 1 -->
                    <tr v-if="allData.exams.length === 1">
                      <th class="text-center" style="width:16.66%">SUBJECT</th>
                      <th style="width:16.66%"
                        class="text-center"
                        v-for="(data, index) in allData.exams"
                        :key="index"
                      >
                        {{ data.name }}
                      </th>
                      <th class="text-center" style="width:16.66%">2nd P/T</th>
                      <th class="text-center" style="width:16.66%">1st Term Test</th>
                      <th class="text-center" style="width:16.66%">2nd Term Test</th>
                      <th class="text-center" style="width:16.66%">
                        Final Result <br />
                        (X+Y)/2 <br />
                      </th>
                    </tr>

                    <!-- PASS MARK & FULL MARK -->
                    <!-- if length = 4 -->
                    <tr v-if="allData.exams.length === 4">
                      <th scope="col"></th>
                      <th v-for="(data, index) in allData.exams" :key="index">
                        F.M:{{getFullMark(data)}} <br>
                        P.M:{{getPassMark(data)}}
                      </th>
                      <th></th>
                    </tr>
                    <!-- if length = 3 -->
                    <tr v-if="allData.exams.length === 3">
                      <th scope="col"></th>
                      <th v-for="(data, index) in allData.exams" :key="index">
                        F.M:{{getFullMark(data)}} <br>
                        P.M:{{getPassMark(data)}}
                      </th>
                      <th>
                        F.M:50 <br />
                        P.M:17
                      </th>
                      <th></th>
                    </tr>
                    <!-- if length = 2 -->
                    <tr v-if="allData.exams.length === 2">
                      <th scope="col"></th>
                      <th v-for="(data, index) in allData.exams" :key="index">
                        F.M:{{getFullMark(data)}} <br>
                        P.M:{{getPassMark(data)}}
                      </th>
                      <th>
                        F.M:50 <br />
                        P.M:17
                      </th>
                      <th>
                        F.M:50 <br />
                        P.M:17
                      </th>
                      <th></th>
                    </tr>
                    <!-- if length = 1 -->
                    <tr v-if="allData.exams.length === 1">
                      <th scope="col"></th>
                      <th v-for="(data, index) in allData.exams" :key="index">
                        F.M:{{getFullMark(data)}} <br>
                        P.M:{{getPassMark(data)}}
                      </th>
                      <th>
                        F.M:40 <br />
                        P.M:14
                      </th>
                      <th>
                        F.M:50 <br />
                        P.M:17
                      </th>
                      <th>
                        F.M:50 <br />
                        P.M:17
                      </th>
                      <th></th>
                    </tr>

                    <!-- SUBJECT & MARK-->
                    <!-- if length=4 -->
                    <tr v-if="allData.exams.length === 4">
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(subjectList, index) in subjects"
                          :key="index"
                        >
                          <div class="Column">
                            {{ subjectList.subject.name }}
                          </div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in subjects"
                            :key="index"
                          >
                            <span
                              :class="
                                getMarksColor(
                                  data.class_section_exams[0]
                                    .student_exam_marks,
                                  examSubject.subject.id
                                )
                              "
                            >
                              {{
                                getMarks(
                                  data.class_section_exams[0]
                                    .student_exam_marks,
                                  examSubject.subject.id
                                )
                              }}
                            </span>
                          </div>
                        </div>
                      </th>
                      <!-- final result mark score -->
                      <th>
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in subjects"
                            :key="index"
                          >
                            NA
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=3 -->
                    <tr v-if="allData.exams.length === 3">
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(subjectList, index) in subjects"
                          :key="index"
                        >
                          <div class="Column">
                            {{ subjectList.subject.name }}
                          </div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in subjects"
                            :key="index"
                          >
                            <span
                              :class="
                                getMarksColor(
                                  data.class_section_exams[0]
                                    .student_exam_marks,
                                  examSubject.subject.id
                                )
                              "
                            >
                              {{
                                getMarks(
                                  data.class_section_exams[0]
                                    .student_exam_marks,
                                  examSubject.subject.id
                                )
                              }}
                            </span>
                          </div>
                        </div>
                      </th>
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(examSubject, index) in subjects"
                          :key="index"
                        >
                          <div class="Column">NA</div>
                        </div>
                      </th>
                      <!-- final result mark score -->
                      <th>
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in subjects"
                            :key="index"
                          >
                            NA
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=2 -->
                    <tr v-if="allData.exams.length === 2">
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(subjectList, index) in subjects"
                          :key="index"
                        >
                          <div class="Column">
                            {{ subjectList.subject.name }}
                          </div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in subjects"
                            :key="index"
                          >
                            <span
                              :class="
                                getMarksColor(
                                  data.class_section_exams[0]
                                    .student_exam_marks,
                                  examSubject.subject.id
                                )
                              "
                            >
                              {{
                                getMarks(
                                  data.class_section_exams[0]
                                    .student_exam_marks,
                                  examSubject.subject.id
                                )
                              }}
                            </span>
                          </div>
                        </div>
                      </th>
                      <!-- 0 mark -->
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(examSubject, index) in subjects"
                          :key="index"
                        >
                          <div class="Column">NA</div>
                        </div>
                      </th>
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(examSubject, index) in subjects"
                          :key="index"
                        >
                          <div class="Column">NA</div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in subjects"
                            :key="index"
                          >
                            NA
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=1 -->
                    <tr v-if="allData.exams.length === 1">
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(subjectList, index) in subjects"
                          :key="index"
                        >
                          <div class="Column">
                            {{ subjectList.subject.name }}
                          </div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in subjects"
                            :key="index"
                          >
                            <span
                              :class="
                                getMarksColor(
                                  data.class_section_exams[0]
                                    .student_exam_marks,
                                  examSubject.subject.id
                                )
                              "
                            >
                              {{
                                getMarks(
                                  data.class_section_exams[0]
                                    .student_exam_marks,
                                  examSubject.subject.id
                                )
                              }}
                            </span>
                          </div>
                        </div>
                      </th>

                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(examSubject, index) in subjects"
                          :key="index"
                        >
                          <div class="Column">NA</div>
                        </div>
                      </th>

                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(examSubject, index) in subjects"
                          :key="index"
                        >
                          <div class="Column">NA</div>
                        </div>
                      </th>

                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(examSubject, index) in subjects"
                          :key="index"
                        >
                          <div class="Column">NA</div>
                        </div>
                      </th>

                      <th>
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in subjects"
                            :key="index"
                          >
                            NA
                          </div>
                        </div>
                      </th>
                    </tr>

                    <!-- SCORE-->
                    <!-- if length=4 -->
                    <tr v-if="allData.exams.length === 4">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Score</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{getTotalMarkScore(data.class_section_exams[0])}}/
                            {{getExamFullMark(data.class_section_exams[0])}}
                          </div>
                        </div>
                      </th>
                      <!-- final result mark score -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=3 -->
                    <tr v-if="allData.exams.length == 3">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Score</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{getTotalMarkScore(data.class_section_exams[0])}}/
                            {{getExamFullMark(data.class_section_exams[0])}}
                          </div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ...0.. -->
                      <th>
                        <div class="column ">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result -->
                    </tr>
                    <!-- if length=2 -->
                    <tr v-if="allData.exams.length == 2">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Score</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{getTotalMarkScore(data.class_section_exams[0])}}/
                            {{getExamFullMark(data.class_section_exams[0])}}
                          </div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result -->
                      <th>
                        <!-- {{data}} -->
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            <!-- {{ markscore.total_mark_score }} /
                        {{ markscore.total_exam_full_mark }} -->NA
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=1 -->
                    <tr v-if="allData.exams.length == 1">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Score</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{getTotalMarkScore(data.class_section_exams[0])}}/
                            {{getExamFullMark(data.class_section_exams[0])}}
                          </div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result -->
                      <th>
                        <!-- {{data}} -->
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            NA
                            <!-- {{ markscore.total_mark_score }} /
                        {{ markscore.total_exam_full_mark }} -->
                          </div>
                        </div>
                      </th>
                    </tr>

                    <!-- PC-->
                    <!-- if length=4 -->
                    <tr v-if="allData.exams.length == 4">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">PC</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getPc((data.class_section_exams[0]))
                            }}%
                          </div>
                        </div>
                      </th>
                      <!-- final result mark score -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=3 -->
                    <tr v-if="allData.exams.length == 3">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">PC</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getPc((data.class_section_exams[0]))
                            }}%
                          </div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ...0.. -->
                      <th>
                        <div class="column ">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result -->
                    </tr>
                    <!-- if length=2 -->
                    <tr v-if="allData.exams.length == 2">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">PC</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column" style="margin:auto">
                          <div class="Row">
                            {{
                              getPc((data.class_section_exams[0]))
                            }}%
                          </div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column" style="margin:auto">
                          <div class="Row">NA</div>
                        </div>
                      </th>
                      <!-- final result -->
                      <th>
                        <!-- {{data}} -->
                        <div class="column" style="margin:auto">
                          <div class="Row">
                            <!-- {{ markscore.total_mark_score }} /
                        {{ markscore.total_exam_full_mark }} -->NA
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=1 -->
                    <tr v-if="allData.exams.length == 1">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">PC</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getPc((data.class_section_exams[0]))
                            }}%
                          </div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result -->
                      <th>
                        <!-- {{data}} -->
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            NA
                            <!-- {{ markscore.total_mark_score }} /
                        {{ markscore.total_exam_full_mark }} -->
                          </div>
                        </div>
                      </th>
                    </tr>

                    <!-- RANK/DIV-->
                    <!-- if length=4 -->
                    <tr v-if="allData.exams.length == 4">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Rank/Div</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getRankDiv((data.class_section_exams[0]))
                            }}
                          </div>
                        </div>
                      </th>
                      <!-- final result mark score -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=3 -->
                    <tr v-if="allData.exams.length == 3">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Rank/Div</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getRankDiv((data.class_section_exams[0]))
                            }}
                          </div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ...0.. -->
                      <th>
                        <div class="column ">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result -->
                    </tr>
                    <!-- if length=2 -->
                    <tr v-if="allData.exams.length == 2">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Rank/Div</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column" style="margin:auto">
                          <div class="Row">
                            {{
                              getRankDiv((data.class_section_exams[0]))
                            }}
                          </div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result -->
                      <th>
                        <!-- {{data}} -->
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            <!-- {{ markscore.total_mark_score }} /
                        {{ markscore.total_exam_full_mark }} -->NA
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=1 -->
                    <tr v-if="allData.exams.length == 1">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Rank/Div</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getRankDiv((data.class_section_exams[0]))
                            }}
                          </div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result -->
                      <th>
                        <!-- {{data}} -->
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            NA
                            <!-- {{ markscore.total_mark_score }} /
                        {{ markscore.total_exam_full_mark }} -->
                          </div>
                        </div>
                      </th>
                    </tr>
                  </table>

                  <!-- TEACHERS REMARK -->
                  <table class="table table-sm table-sm-responsive table-bordered" style="font-size:12px;margin:0px">
                    <!-- Remarks -->
                    <tr>
                      <th colspan="4">
                          Teachers Remark
                      </th>
                      <!-- ...... data....... -->
                    </tr>
                    <!-- if length = 4 -->
                    <tr v-if="allData.exams.length == 4">
                      <th
                        style="width: 16%"
                        v-for="data in allData.exams"
                        :key="data.exam_id"
                      >
                        {{ data.name }} :......................
                      </th>
                    </tr>
                    <!-- if length = 3 -->
                    <tr v-if="allData.exams.length == 3">
                      <th
                        style="width: 16%"
                        v-for="data in allData.exams"
                        :key="data.exam_id"
                      >
                        {{ data.name }} :......................
                      </th>

                      <th style="width: 16%">
                        2nd T/T :......................
                      </th>
                    </tr>
                    <!-- if length = 2 -->
                    <tr v-if="allData.exams.length == 2">
                      <th
                        style="width: 16%"
                        v-for="(data, index) in allData.exams"
                        :key="index"
                      >
                        {{ data.name }} :......................
                      </th>
                      <th style="width: 16%">
                        1st T/T :......................
                      </th>
                      <th style="width: 16%">
                        2nd T/T :......................
                      </th>
                    </tr>
                    <!-- if length = 1 -->
                    <tr v-if="allData.exams.length == 1">
                      <th
                        style="width: 16%"
                        v-for="(data, index) in allData.exams"
                        :key="index"
                      >
                        {{ data.name }} :......................
                      </th>
                      <th class="text-center" style="width: 16%">
                        2nd P/T :......................
                      </th>
                      <th class="text-center" style="width: 16%">
                        1st-T/T :......................
                      </th>
                      <th class="text-center" style="width: 16%">
                        2nd T/T :......................
                      </th>
                    </tr>
                  </table>
                  <table class="table table-sm table-sm-responsive" style="font-size:12px;margin-top:0px">
                      <!-- Top Exam row -->
                      <tr>
                        <th style="width:50%">Teacher's signature</th>
                        <th style="width:50%">Principal</th>
                      </tr>
                  </table>
                </vue-custom-scrollbar>
              </div>
              <div class="col-12" v-else>
                <vue-custom-scrollbar class="scroll-area">
                  <!-- trail -->
                  <table
                    class="table table-sm table-sm-responsive table-bordered "
                    style="font-size:13px"
                  >
                    <!-- top -->
                    <tr>
                      <th></th>
                      <th :colspan="4" style="text-align: center">
                        X-Periodic Tests + Internal Assessment <br />
                        Marks Secured
                      </th>
                      <th style="text-align: center">
                        Y-1st & 2nd Term Test <br />
                        Marks Secured
                      </th>
                      <th></th>
                    </tr>

                    <!--  2nd row subject and Exam column-->
                    <!-- if length = 5 -->
                    <tr v-if="allData.exams.length === 5">
                      <th class="text-center" style="width:14.28%">SUBJECT</th>
                      <th style="width:14.28%"
                          class="text-center"
                          v-for="(data, index) in allData.exams"
                          :key="index"
                      >
                        {{ data.name }}
                      </th>
                      <th class="text-center" style="width:14.28%">
                        Final Result <br />
                        (X+Y)/2 <br />
                      </th>
                    </tr>
                    <!-- if length = 4 -->
                    <tr v-if="allData.exams.length === 4">
                      <th class="text-center" style="width:14.28%">SUBJECT</th>
                      <th style="width:14.28%"
                        class="text-center"
                        v-for="(data, index) in allData.exams"
                        :key="index"
                      >
                        {{ data.name }}
                      </th>
                      <th class="text-center" style="width:14.28%">2nd Term Test</th>
                      <th class="text-center" style="width:14.28%">
                        Final Result <br />
                        (X+Y)/2 <br />
                      </th>
                    </tr>
                    <!-- if length = 3 -->
                    <tr v-if="allData.exams.length === 3">
                      <th class="text-center" style="width:14.28%">SUBJECT</th>
                      <th style="width:14.28%"
                        class="text-center"
                        v-for="(data, index) in allData.exams"
                        :key="index"
                      >
                        {{ data.name }}
                      </th>
                      <th class="text-center" style="width:14.28%">Int. Assess</th>
                      <th class="text-center" style="width:14.28%">2nd Term Test</th>
                      <th class="text-center" style="width:14.28%">
                        Final Result <br />
                        (X+Y)/2 <br />
                      </th>
                    </tr>
                    <!-- if length = 2 -->
                    <tr v-if="allData.exams.length === 2">
                      <th class="text-center" style="width:14.28%">SUBJECT</th>
                      <th style="width:14.28%"
                        class="text-center"
                        v-for="(data, index) in allData.exams"
                        :key="index"
                      >
                        {{ data.name }}
                      </th>
                      <th class="text-center" style="width:14.28%">1st Term test</th>
                      <th class="text-center" style="width:14.28%">Int. Assess</th>
                      <th class="text-center" style="width:14.28%">2nd Term Test</th>
                      <th class="text-center" style="width:14.28%">
                        Final Result <br />
                        (X+Y)/2 <br />
                      </th>
                    </tr>
                    <!-- if length = 1 -->
                    <tr v-if="allData.exams.length === 1">
                      <th class="text-center" style="width:14.28%">SUBJECT</th>
                      <th style="width:14.28%"
                        class="text-center"
                        v-for="(data, index) in allData.exams"
                        :key="index"
                      >
                        {{ data.name }}
                      </th>
                      <th class="text-center" style="width:14.28%">2nd P/T</th>
                      <th class="text-center" style="width:14.28%">1st Term Test</th>
                      <th class="text-center" style="width:14.28%">Int. Assess</th>
                      <th class="text-center" style="width:14.28%">2nd Term Test</th>
                      <th class="text-center" style="width:14.28%">
                        Final Result <br />
                        (X+Y)/2 <br />
                      </th>
                    </tr>

                    <!-- PASS MARK & FULL MARK -->
                    <!-- if length = 5 -->
                    <tr v-if="allData.exams.length === 5">
                      <th scope="col"></th>
                      <th v-for="(data, index) in allData.exams" :key="index">
                        F.M:{{getFullMark(data)}} <br>
                        P.M:{{getPassMark(data)}}
                      </th>
                      <th></th>
                    </tr>
                    <!-- if length = 4 -->
                    <tr v-if="allData.exams.length === 4">
                      <th scope="col"></th>
                      <th v-for="(data, index) in allData.exams" :key="index">
                        F.M:{{getFullMark(data)}} <br>
                        P.M:{{getPassMark(data)}}
                      </th>
                      <th>
                        F.M:50 <br />
                        P.M:17
                      </th>
                      <th></th>
                    </tr>
                    <!-- if length = 3 -->
                    <tr v-if="allData.exams.length === 3">
                      <th scope="col"></th>
                      <th v-for="(data, index) in allData.exams" :key="index">
                        F.M:{{getFullMark(data)}} <br>
                        P.M:{{getPassMark(data)}}
                      </th>
                      <th>
                        F.M:20 <br />
                        P.M:7
                      </th>
                      <th>
                        F.M:50 <br />
                        P.M:17
                      </th>
                      <th></th>
                    </tr>
                    <!-- if length = 2 -->
                    <tr v-if="allData.exams.length === 2">
                      <th scope="col"></th>
                      <th v-for="(data, index) in allData.exams" :key="index">
                        F.M:{{getFullMark(data)}} <br>
                        P.M:{{getPassMark(data)}}
                      </th>
                      <th>
                        F.M:50 <br />
                        P.M:17
                      </th>
                      <th>
                        F.M:20 <br />
                        P.M:7
                      </th>
                      <th>
                        F.M:50 <br />
                        P.M:17
                      </th>
                      <th></th>
                    </tr>
                    <!-- if length = 1 -->
                    <tr v-if="allData.exams.length === 1">
                      <th scope="col"></th>
                      <th v-for="(data, index) in allData.exams" :key="index">
                        F.M:{{getFullMark(data)}} <br>
                        P.M:{{getPassMark(data)}}
                      </th>
                      <th>
                        F.M:40 <br />
                        P.M:14
                      </th>
                      <th>
                        F.M:50 <br />
                        P.M:17
                      </th>
                      <th>
                        F.M:20 <br />
                        P.M:7
                      </th>
                      <th>
                        F.M:50 <br />
                        P.M:17
                      </th>
                      <th></th>
                    </tr>

                    <!-- SUBJECT & MARK-->
                    <!-- if length=5 -->
                    <tr v-if="allData.exams.length === 5">
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(subjectList, index) in subjects"
                          :key="index"
                        >
                          <div class="Column">
                            {{ subjectList.subject.name }}
                          </div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in subjects"
                            :key="index"
                          >
                            <span
                              :class="
                                getMarksColor(
                                  data.class_section_exams[0]
                                    .student_exam_marks,
                                  examSubject.subject.id
                                )
                              "
                            >
                              {{
                                getMarks(
                                  data.class_section_exams[0]
                                    .student_exam_marks,
                                  examSubject.subject.id
                                )
                              }}
                            </span>
                          </div>
                        </div>
                      </th>
                      <!-- final result mark score -->
                      <th>
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in subjects"
                            :key="index"
                          >
                            NA
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=4 -->
                    <tr v-if="allData.exams.length === 4">
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(subjectList, index) in subjects"
                          :key="index"
                        >
                          <div class="Column">
                            {{ subjectList.subject.name }}
                          </div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in subjects"
                            :key="index"
                          >
                            <span
                              :class="
                                getMarksColor(
                                  data.class_section_exams[0]
                                    .student_exam_marks,
                                  examSubject.subject.id
                                )
                              "
                            >
                              {{
                                getMarks(
                                  data.class_section_exams[0]
                                    .student_exam_marks,
                                  examSubject.subject.id
                                )
                              }}
                            </span>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in subjects"
                            :key="index"
                          >
                            NA
                          </div>
                        </div>
                      </th>
                      <!-- final result mark score -->
                      <th>
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in subjects"
                            :key="index"
                          >
                            NA
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=3 -->
                    <tr v-if="allData.exams.length === 3">
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(subjectList, index) in subjects"
                          :key="index"
                        >
                          <div class="Column">
                            {{ subjectList.subject.name }}
                          </div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in subjects"
                            :key="index"
                          >
                            <span
                              :class="
                                getMarksColor(
                                  data.class_section_exams[0]
                                    .student_exam_marks,
                                  examSubject.subject.id
                                )
                              "
                            >
                              {{
                                getMarks(
                                  data.class_section_exams[0]
                                    .student_exam_marks,
                                  examSubject.subject.id
                                )
                              }}
                            </span>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in subjects"
                            :key="index"
                          >
                            NA
                          </div>
                        </div>
                      </th>
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(examSubject, index) in subjects"
                          :key="index"
                        >
                          <div class="Column">NA</div>
                        </div>
                      </th>
                      <!-- final result mark score -->
                      <th>
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in subjects"
                            :key="index"
                          >
                            NA
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=2 -->
                    <tr v-if="allData.exams.length === 2">
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(subjectList, index) in subjects"
                          :key="index"
                        >
                          <div class="Column">
                            {{ subjectList.subject.name }}
                          </div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in subjects"
                            :key="index"
                          >
                            <span
                              :class="
                                getMarksColor(
                                  data.class_section_exams[0]
                                    .student_exam_marks,
                                  examSubject.subject.id
                                )
                              "
                            >
                              {{
                                getMarks(
                                  data.class_section_exams[0]
                                    .student_exam_marks,
                                  examSubject.subject.id
                                )
                              }}
                            </span>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in subjects"
                            :key="index"
                          >
                            NA
                          </div>
                        </div>
                      </th>
                      <!-- 0 mark -->
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(examSubject, index) in subjects"
                          :key="index"
                        >
                          <div class="Column">NA</div>
                        </div>
                      </th>
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(examSubject, index) in subjects"
                          :key="index"
                        >
                          <div class="Column">NA</div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in subjects"
                            :key="index"
                          >
                            NA
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=1 -->
                    <tr v-if="allData.exams.length === 1">
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(subjectList, index) in subjects"
                          :key="index"
                        >
                          <div class="Column">
                            {{ subjectList.subject.name }}
                          </div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in subjects"
                            :key="index"
                          >
                            <span
                              :class="
                                getMarksColor(
                                  data.class_section_exams[0]
                                    .student_exam_marks,
                                  examSubject.subject.id
                                )
                              "
                            >
                              {{
                                getMarks(
                                  data.class_section_exams[0]
                                    .student_exam_marks,
                                  examSubject.subject.id
                                )
                              }}
                            </span>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in subjects"
                            :key="index"
                          >
                            NA
                          </div>
                        </div>
                      </th>
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(examSubject, index) in subjects"
                          :key="index"
                        >
                          <div class="Column">NA</div>
                        </div>
                      </th>

                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(examSubject, index) in subjects"
                          :key="index"
                        >
                          <div class="Column">NA</div>
                        </div>
                      </th>

                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(examSubject, index) in subjects"
                          :key="index"
                        >
                          <div class="Column">NA</div>
                        </div>
                      </th>

                      <th>
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in subjects"
                            :key="index"
                          >
                            NA
                          </div>
                        </div>
                      </th>
                    </tr>

                    <!-- SCORE-->
                    <!-- if length=5 -->
                    <tr v-if="allData.exams.length === 5">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Score</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{getTotalMarkScore(data.class_section_exams[0])}}/
                            {{getExamFullMark(data.class_section_exams[0])}}
                          </div>
                        </div>
                      </th>
                      <!-- final result mark score -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=4 -->
                    <tr v-if="allData.exams.length === 4">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Score</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{getTotalMarkScore(data.class_section_exams[0])}}/
                            {{getExamFullMark(data.class_section_exams[0])}}
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result mark score -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=3 -->
                    <tr v-if="allData.exams.length == 3">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Score</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{getTotalMarkScore(data.class_section_exams[0])}}/
                            {{getExamFullMark(data.class_section_exams[0])}}
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ...0.. -->
                      <th>
                        <div class="column ">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result -->
                    </tr>
                    <!-- if length=2 -->
                    <tr v-if="allData.exams.length == 2">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Score</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{getTotalMarkScore(data.class_section_exams[0])}}/
                            {{getExamFullMark(data.class_section_exams[0])}}
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result -->
                      <th>
                        <!-- {{data}} -->
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            <!-- {{ markscore.total_mark_score }} /
                        {{ markscore.total_exam_full_mark }} -->NA
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=1 -->
                    <tr v-if="allData.exams.length == 1">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Score</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{getTotalMarkScore(data.class_section_exams[0])}}/
                            {{getExamFullMark(data.class_section_exams[0])}}
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result -->
                      <th>
                        <!-- {{data}} -->
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            NA
                            <!-- {{ markscore.total_mark_score }} /
                        {{ markscore.total_exam_full_mark }} -->
                          </div>
                        </div>
                      </th>
                    </tr>

                    <!-- PC-->
                    <!-- if length=5 -->
                    <tr v-if="allData.exams.length == 5">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">PC</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getPc((data.class_section_exams[0]))
                            }}%
                          </div>
                        </div>
                      </th>
                      <!-- final result mark score -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=4 -->
                    <tr v-if="allData.exams.length == 4">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">PC</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getPc((data.class_section_exams[0]))
                            }}%
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result mark score -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=3 -->
                    <tr v-if="allData.exams.length == 3">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">PC</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getPc((data.class_section_exams[0]))
                            }}%
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ...0.. -->
                      <th>
                        <div class="column ">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result -->
                    </tr>
                    <!-- if length=2 -->
                    <tr v-if="allData.exams.length == 2">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">PC</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getPc((data.class_section_exams[0]))
                            }}%
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result -->
                      <th>
                        <!-- {{data}} -->
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            <!-- {{ markscore.total_mark_score }} /
                        {{ markscore.total_exam_full_mark }} -->NA
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=1 -->
                    <tr v-if="allData.exams.length == 1">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">PC</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getPc((data.class_section_exams[0]))
                            }}%
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result -->
                      <th>
                        <!-- {{data}} -->
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            NA
                            <!-- {{ markscore.total_mark_score }} /
                        {{ markscore.total_exam_full_mark }} -->
                          </div>
                        </div>
                      </th>
                    </tr>

                    <!-- RANK/DIV-->
                    <!-- if length=5 -->
                    <tr v-if="allData.exams.length == 5">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Rank/Div</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getRankDiv((data.class_section_exams[0]))
                            }}
                          </div>
                        </div>
                      </th>
                      <!-- final result mark score -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=4 -->
                    <tr v-if="allData.exams.length == 4">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Rank/Div</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getRankDiv((data.class_section_exams[0]))
                            }}
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result mark score -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=3 -->
                    <tr v-if="allData.exams.length == 3">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Rank/Div</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getRankDiv((data.class_section_exams[0]))
                            }}
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ...0.. -->
                      <th>
                        <div class="column ">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result -->
                    </tr>
                    <!-- if length=2 -->
                    <tr v-if="allData.exams.length == 2">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Rank/Div</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getRankDiv((data.class_section_exams[0]))
                            }}
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result -->
                      <th>
                        <!-- {{data}} -->
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            <!-- {{ markscore.total_mark_score }} /
                        {{ markscore.total_exam_full_mark }} -->NA
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=1 -->
                    <tr v-if="allData.exams.length == 1">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Rank/Div</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getRankDiv((data.class_section_exams[0]))
                            }}
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result -->
                      <th>
                        <!-- {{data}} -->
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            NA
                            <!-- {{ markscore.total_mark_score }} /
                        {{ markscore.total_exam_full_mark }} -->
                          </div>
                        </div>
                      </th>
                    </tr>
                  </table>

                  <!-- TEACHERS REMARK -->
                  <table class="table table-sm table-sm-responsive" style="font-size:11px;margin:0px">
                    <!-- Remarks -->
                    <tr>
                      <th colspan="4">
                          <span style="font-size:11px"> Teachers Remark </span>
                      </th>
                      <!-- ...... data....... -->
                    </tr>
                    <!-- if length = 4 -->
                    <tr v-if="allData.exams.length == 4">
                      <th
                        style="width: 16%"
                        v-for="data in allData.exams"
                        :key="data.exam_id"
                      >
                        <span style="font-size:11px">{{ data.name }} :......................</span>
                      </th>
                    </tr>
                    <!-- if length = 3 -->
                    <tr v-if="allData.exams.length == 3">
                      <th
                        style="width: 16%"
                        v-for="data in allData.exams"
                        :key="data.exam_id"
                      >
                        <span style="font-size:11px">{{ data.name }} :......................</span>
                      </th>

                      <th style="width: 16%;font-size:11px">
                        <span style="font-size:11px">2nd T/T :......................</span>
                      </th>
                    </tr>
                    <!-- if length = 2 -->
                    <tr v-if="allData.exams.length == 2">
                      <th
                        style="width: 16%"
                        v-for="(data, index) in allData.exams"
                        :key="index"
                      >
                        <span style="font-size:11px">{{ data.name }} :......................</span>
                      </th>
                      <th style="width: 16%">
                        <span style="font-size:11px">1st T/T :......................</span>
                      </th>
                      <th style="width: 16%">
                        <span style="font-size:11px">2nd T/T :......................</span>
                      </th>
                    </tr>
                    <!-- if length = 1 -->
                    <tr v-if="allData.exams.length == 1">
                      <th
                        style="width: 16%"
                        v-for="(data, index) in allData.exams"
                        :key="index"
                      >
                        <span style="font-size:11px">{{ data.name }} :......................</span>
                      </th>
                      <th class="text-center" style="width: 16%">
                        <span style="font-size:11px">2nd P/T :......................</span>
                      </th>
                      <th class="text-center" style="width: 16%">
                        <span style="font-size:11px">1st-T/T :......................</span>
                      </th>
                      <th class="text-center" style="width: 16%">
                        <span style="font-size:11px">2nd T/T :......................</span>
                      </th>
                    </tr>
                  </table>
                  <table class="table table-sm table-sm-responsive" style="font-size:11px;margin-top:0px">
                      <!-- Top Exam row -->
                      <tr>
                        <th style="width:33%;text-align:center"><span style="font-size:11px">
                          Teacher's signature</span></th>
                        <th style="width:33%;text-align:center"><span style="font-size:11px">
                          Parent's signature</span></th>
                        <th style="width:33%;text-align:center"><span style="font-size:11px">
                          Principal</span></th>
                      </tr>
                  </table>
                  <b style="font-size: 11px">
                    N.B : Marks of final T/T is 100/2 = 50, so that we can
                    calculate (X+Y) /2 as per board norm.</b>
                </vue-custom-scrollbar>
              </div>
            </div>
          </a-spin>
        </neo-print-wrapper>
        <div class="position-absolute neo-tr-5 d-print-none">
          <button
            type="button"
            class="btn btn-light btn-sm btn-with-addon"
            @click="print"
          >
            <span class="btn-addon">
              <i class="btn-addon-icon fe fe-printer" />
            </span>
            Print
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'
import NeoPrintWrapper from '@/components/layout/Print/Default'
export default {
  name: 'bulkreportcard',
  components: {
    vueCustomScrollbar,

    NeoPrintWrapper,
  },
  computed: {
    class_Id: function() {
      return this.$route.params.classId
    },
    exams_Id: function() {
      return this.$route.params.examsId
    },
    section_Id: function() {
      return this.$route.params.sectionId
    },
    session_Id: function() {
      return this.$route.params.sessionId
    },
    reportCardFormat: function() {
      return this.$route.params.reportFormat
    },
  },
  watch: {
    enrollment: function(val) {
      return val
    },
    className: function(val) {
      return val
    },
    sectionName: function(val) {
      return val
    },
  },
  data: function() {
    return {
      reportData: [],
      selectedExams: [],
      schoolData: [],
      enrollment: [],
      subjects: [],
      loading: false,
      className: '',
      sectionName: '',
    }
  },
  created: function() {
    // console.log('here')
    this.getBulkReport()
    this.getClassDetails()
    this.getSectionDetails()
  },
  methods: {
    getRankDiv(totalScoreData) {
      var rankDiv = ''
      const getClassSectionData = JSON.parse(JSON.stringify(totalScoreData)).student_declared_marks
      if (getClassSectionData.length > 0) {
        getClassSectionData.forEach(function(value) {
          if (value.rank !== null) {
            rankDiv = value.rank
          } else if (value.division !== null) {
            rankDiv = value.division
          } else if (value.rank === null && value.division === null) {
            rankDiv = 'NA'
          }
        })
      } else {
        rankDiv = 'NA'
      }
      return rankDiv
    },
    getPc(Data) {
      var pc = ''
      const getClassSectionData = JSON.parse(JSON.stringify(Data)).student_declared_marks
      if (getClassSectionData.length > 0) {
        getClassSectionData.forEach(function(value) {
          pc = value.mark_percentage
        })
      } else {
        pc = 'NA'
      }
      return pc
    },
    getExamFullMark(totalScoreData) {
      var totalScoreMark = ''
      const getClassSectionData = JSON.parse(JSON.stringify(totalScoreData)).student_declared_marks
      if (getClassSectionData.length > 0) {
        getClassSectionData.forEach(function(value) {
          totalScoreMark = value.total_exam_full_mark
        })
      } else {
        totalScoreMark = 'NA'
      }
      return totalScoreMark
    },
    getTotalMarkScore(totalScoreData) {
      var totalScoreMark = ''
      const getClassSectionData = JSON.parse(JSON.stringify(totalScoreData)).student_declared_marks
      if (getClassSectionData.length > 0) {
        getClassSectionData.forEach(function(value) {
          totalScoreMark = value.total_mark_score
        })
      } else {
        totalScoreMark = 'NA'
      }
      return totalScoreMark
    },
    getFullMark(markData) {
      // let collectData = null
      var fullmark = null
      const getClassSectionData = JSON.parse(JSON.stringify(markData)).class_section_exams
      getClassSectionData.forEach(function(value) {
        fullmark = value.student_exam_marks.filter(obj => obj.exam_full_mark != null && obj.is_in_total === 1)
      })
      if (fullmark.length !== 0) {
        return fullmark[0].exam_full_mark
      }
    },
    getPassMark(markData) {
      var passmark = null
      const getClassSectionData = JSON.parse(JSON.stringify(markData)).class_section_exams
      getClassSectionData.forEach(function(value) {
        passmark = value.student_exam_marks.filter(obj => obj.exam_pass_mark != null && obj.is_in_total === 1)
      })
      if (passmark.length !== 0) {
        return passmark[0].exam_pass_mark
      }
    },
    getMarks(marksArray, subjeectId) {
      var foundValue = marksArray.filter(obj => obj.subject_id === subjeectId)
      if (foundValue.length !== 0) {
        var newObj = Object.assign({}, ...foundValue)
        if (newObj.is_absent === 0) {
          // if exam_mark_score
          if (newObj.exam_mark_score !== null) {
            return newObj.exam_mark_score
          } else if (newObj.exam_mark_grade !== null) {
            return newObj.exam_mark_grade
          } else if (newObj.exam_mark_grade === null && newObj.exam_mark_score === null) {
            const absent = '--'
            return absent
          } else {
            const absent = '--'
            return absent
          }
        } else {
          const absent = 'AB'
          return absent
        }
      } else {
        const noDatafound = '--'
        return noDatafound
      }
    },
    getMarksColor(marksArray, subjeectId) {
      // console.log("marks", marksArray)
      var foundValue = marksArray.filter(obj => obj.subject_id === subjeectId)
      // const y = find(x ["subject_id", u])
      if (foundValue.length !== 0) {
        // var mapped = foundValue.map(item => ({ [item.exam_mark_score]: item.subject_id }))
        var newObj = Object.assign({}, ...foundValue)
        // console.log(newObj);
        if (newObj.is_absent === 1) {
          return 'text-danger'
        } else {
          if (newObj.is_failed === 1) {
            return 'text-danger'
          } else {
            return 'text-dark'
          }
        }
      } else {
        return 'text-danger'
      }
    },
    print() {
      this.$htmlToPaper('examResultSingle')
    },
    getBulkReport() {
      this.loading = true
      this.$http
        .get('/api/reports/exams/class_section', {
          params: {
            section_id: this.section_Id,
            class_id: this.class_Id,
            exams: this.exams_Id,
          },
        })
        .then(({ data }) => {
          this.subjects = data.data.subject_data
          this.enrollment = data.data.enrollment
          this.schoolData = data.data.school_data
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$neoNotify.error(error)
        })
      // this.getClassExamData(this.checkedClassId);
    },
    getClassDetails() {
      // eslint-disable-next-line space-before-blocks
      if (this.class_Id){
        this.$http
          .get(`/api/class/${this.class_Id}`)
          .then(({ data }) => {
            this.className = data.data.name
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    getSectionDetails() {
      // eslint-disable-next-line space-before-blocks
      if (this.section_Id){
        this.$http
          .get(`/api/section/${this.section_Id}`)
          .then(({ data }) => {
            this.sectionName = data.data.name
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    handleBackButton() {
      this.$router.push({ name: 'report_cards' })
    },
  },
}
</script>
